module.exports = __webpack_public_path__ + "img/io.23eab627.svg";